import { AppState } from './../../../../App.state';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PagamentosPorClientes } from 'src/app/base/domain/dto/pagamentos-por-clientes.dto';
import { NovoDashboardService } from 'src/app/base/services/novo-dashboard.service';
import { DialogService } from 'src/app/global/services/dialog.service';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

@Component({
  selector: 'app-dashboard-pagamentos-por-clientes',
  templateUrl: './dashboard-pagamentos-por-clientes.component.html',
  styleUrls: ['./dashboard-pagamentos-por-clientes.component.css']
})
export class DashboardPagamentosPorClientesComponent implements OnInit {

  @ViewChild('graficoPagamentos', { static: false })
  canvas!: ElementRef<HTMLCanvasElement>;

  nome: string = '';
  queryOptions = new QueryOptions({ pageSize: 100 });
  data: PagamentosPorClientes[] = [];
  searched: boolean = false;
  chart?: Chart;

  // Totals
  totalContrato: number = 0;
  totalPago: number = 0;
  totalSaldoDevedor: number = 0;

  constructor(
    private service: NovoDashboardService,
    private appState: AppState,
    public dialogService: DialogService
  ) { }

  ngOnInit(): void { }

  public buscar(): void {
    if (!this.nome || this.nome.length < 3) {
      this.dialogService.feedbackError('Informe pelo menos 3 caracteres do nome para consultar.');
      return;
    }
    this.loadDashboard();
  }

  private loadDashboard(): void {
    this.appState.isLoading = true;
    this.searched = true;
    this.queryOptions.params = { nome: this.nome };

    this.service.findAllPagamentosPorClientes(this.queryOptions).subscribe({
      next: (response: PagamentosPorClientes[]) => {
        this.data = response;
        this.calculateTotals();
        this.buildChart();
        this.appState.isLoading = false;
      },
      error: () => {
        this.dialogService.feedbackError("Erro ao carregar o dashboard de pagamentos por clientes.");
        this.appState.isLoading = false;
      }
    });

  }

  private calculateTotals(): void {
    this.totalContrato = this.data.reduce((acc, item) => acc + (item.valorContrato || 0), 0);
    this.totalPago = this.data.reduce((acc, item) => acc + (item.totalPago || 0), 0);
    this.totalSaldoDevedor = this.data.reduce((acc, item) => acc + (item.saldoDevedor || 0), 0);
  }

  private buildChart(): void {
    if (this.chart) {
      this.chart.destroy();
    }

    if (!this.data || this.data.length === 0) return;

    // Use setTimeout to ensure canvas is rendered
    setTimeout(() => {
      if (!this.canvas) return;

      const labels = this.data.map(item => `Contrato ${item.contratoId}`);
      const valorContratoData = this.data.map(item => item.valorContrato);
      const totalPagoData = this.data.map(item => item.totalPago);

      this.chart = new Chart(this.canvas.nativeElement, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Valor Contrato',
              data: valorContratoData,
              backgroundColor: '#42a5f5',
              borderRadius: 5
            },
            {
              label: 'Total Pago',
              data: totalPagoData,
              backgroundColor: '#66bb6a',
              borderRadius: 5
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true, position: 'top' },
            tooltip: {
              callbacks: {
                label: (context) => {
                  let label = context.dataset.label || '';
                  if (label) label += ': ';
                  if (context.parsed.y !== null) {
                    label += new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(context.parsed.y);
                  }
                  return label;
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: (value) => {
                  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }).format(value as number);
                }
              }
            }
          }
        }
      });
    }, 100);
  }

  public getDate(dateArray: any): Date | null {
    if (!dateArray) return null;
    if (Array.isArray(dateArray) && dateArray.length >= 3) {
      return new Date(dateArray[0], dateArray[1] - 1, dateArray[2], dateArray[3] || 0, dateArray[4] || 0);
    }
    return new Date(dateArray);
  }
}
